// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { OnboardingInfoSignupIntent, Borough, LeaseType } from "./globalTypes";

// ====================================================
// GraphQL fragment: OnboardingInfo
// ====================================================

export interface OnboardingInfo {
  /**
   * The reason the user originally signed up with us.
   */
  signupIntent: OnboardingInfoSignupIntent;
  /**
   * The user's address. Only street name and number are required.
   */
  address: string;
  /**
   * The non-NYC city the user's address is in, if they live outside of NYC.
   */
  nonNycCity: string;
  /**
   * The user's ZIP code. This field is automatically updated for NYC users when you change the address or borough.
   */
  zipcode: string;
  /**
   * The user's Boro, Block, and Lot number. This field is automatically updated
   * for NYC users when you change the address or borough.
   */
  padBbl: string;
  aptNumber: string;
  /**
   * The floor number the user's apartment is on.
   */
  floorNumber: number | null;
  /**
   * Has the user called 311 before?
   */
  hasCalled311: boolean | null;
  /**
   * Does the user receive public assistance, e.g. Section 8?
   */
  receivesPublicAssistance: boolean | null;
  /**
   * Whether the user has agreed to the JustFix.nyc terms of service and privacy policy.
   */
  agreedToJustfixTerms: boolean;
  /**
   * Whether the user has agreed to the NoRent.org terms of service and privacy policy.
   */
  agreedToNorentTerms: boolean;
  /**
   * Whether the user has agreed to the Eviction Free terms of service and privacy policy.
   */
  agreedToEvictionfreeTerms: boolean;
  /**
   * Whether the user has agreed to the LA Letter Builder terms of service and privacy policy.
   */
  agreedToLaletterbuilderTerms: boolean;
  /**
   * Whether the user has opted-in to being contacted by the Right to the City Alliance (RTTC).
   */
  canReceiveRttcComms: boolean | null;
  /**
   * Whether the user has opted-in to being contacted by Strategic Actions for a Just Economy (SAJE).
   */
  canReceiveSajeComms: boolean | null;
  /**
   * The New York City borough the user's address is in, if they live inside NYC.
   */
  borough: Borough | null;
  /**
   * The type of housing the user lives in (NYC only).
   */
  leaseType: LeaseType | null;
  /**
   * The two-letter state or territory of the user, e.g. "NY".
   */
  state: string;
  /**
   * The city of the user. For NYC-based users, this will be the same as
   *         the borough name, except we use "New York" instead of "Manhattan".
   */
  city: string;
  /**
   * Whether the user is in Los Angeles County. If we don't have enough information to tell, this will be null.
   */
  isInLosAngeles: boolean | null;
  /**
   * The user's full mailing address, as it will appear on mailings and other official documents.
   */
  fullMailingAddress: string;
  /**
   * The county of the user's address, or null if we don't know.
   */
  county: string | null;
}

export const BlankOnboardingInfo: OnboardingInfo = {
  "signupIntent": OnboardingInfoSignupIntent.LOC,
  "address": "",
  "nonNycCity": "",
  "zipcode": "",
  "padBbl": "",
  "aptNumber": "",
  "floorNumber": null,
  "hasCalled311": null,
  "receivesPublicAssistance": null,
  "agreedToJustfixTerms": false,
  "agreedToNorentTerms": false,
  "agreedToEvictionfreeTerms": false,
  "agreedToLaletterbuilderTerms": false,
  "canReceiveRttcComms": null,
  "canReceiveSajeComms": null,
  "borough": null,
  "leaseType": null,
  "state": "",
  "city": "",
  "isInLosAngeles": null,
  "fullMailingAddress": "",
  "county": null
};

export const graphQL = `# This file was auto-generated by querybuilder, please do not edit it.
fragment OnboardingInfo on OnboardingInfoType {
  signupIntent,
  address,
  nonNycCity,
  zipcode,
  padBbl,
  aptNumber,
  floorNumber,
  hasCalled311,
  receivesPublicAssistance,
  agreedToJustfixTerms,
  agreedToNorentTerms,
  agreedToEvictionfreeTerms,
  agreedToLaletterbuilderTerms,
  canReceiveRttcComms,
  canReceiveSajeComms,
  borough,
  leaseType,
  state,
  city,
  isInLosAngeles,
  fullMailingAddress,
  county
}`;